module.exports = __webpack_public_path__ + "static2023-4-17/img/week_2_active.dbe8fbc6.png";